<template>
  <div>
    <div class="modal is-modal-large" :class="{'is-active': active}">
      <div class="modal-background" @click.prevent.stop="close"></div>
      <div class="modal-card">
        <div class="row-width-actions-bar">
          <div class="columns is-gapless is-vcentered is-border-bottom">
            <div class="column is-padding-left">
              <div class="has-text-dark is-size-6 is-uppercase">
                <span class="has-text-weight-medium">{{params.title || 'Documents'}}</span>
              </div>
            </div>
            <div class="column is-narrow is-border-left">
              <a class="page-header-btn is-small is-square" @click="close">
                <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
              </a>
            </div>
          </div>
        </div>
        <section class="modal-card-body is-clipped">
          <div class="columns is-gapless is-clipped is-max-height-full">
            <div class="column is-12 is-border-right is-overflow-auto">
              <form @submit.prevent.stop="submit()" id="form-user">
                <div class="columns is-multiline is-border-top is-padding-bottom">
                  <div class="column is-gapless is-paddingless is-12 columns is-multiline">
                    <div class="column is-4 is-padding-left is-padding-right is-padding-top">
                      <r-label :label="'Nom de la société'" :redCheck='true' :value="promoteur.company_name"></r-label>
                      <v-input id="company_name" name="company_name" @input="val => promoteur.company_name = val" :model="promoteur.company_name"
                              data-vv-as="Nom de la société"
                              v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val">
                      </v-input>
                    </div>
                    <div class="column is-4 is-padding-left is-padding-right is-padding-top">
                      <r-label :label="'Nom du représentant'" :value="promoteur.last_name" :redCheck='true'></r-label>
                      <v-input id="last_name" name="last_name" @input="val => promoteur.last_name = val" :model="promoteur.last_name"
                              data-vv-as="Nom"
                              v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val">
                      </v-input>
                    </div>
                    <div class="column is-4 is-padding-left is-padding-right is-padding-top">
                      <r-label :label="'Prénom du représentant'" :value="promoteur.first_name" :redCheck='true'></r-label>
                      <v-input id="first_name" name="first_name" @input="val => promoteur.first_name = val" :model="promoteur.first_name"
                              v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val"
                              data-vv-as="Prénom">
                      </v-input>
                    </div>
                    <div class="column is-6 is-padding-left is-padding-right is-padding-top">
                      <r-label :label="'Adresse mail'" :value="promoteur.email" :redCheck='true'></r-label>
                      <div class="field has-addons">
                        <div class="control">
                          <a class="button is-static is-border is-min-width-0 is-square">
                            <span class="icon"><i class="fas fa-envelope"></i></span>
                          </a>
                        </div>
                        <div class="control is-expanded">
                          <v-input id="email" name="email" @input="val => promoteur.email = val" :model="promoteur.email" class=""
                              v-validate="'email'" :errors-bag="errors" data-vv-value-path="val"
                              data-vv-as="Email">
                          </v-input>
                        </div>
                      </div>
                    </div>
                    <div class="column is-6 is-3-widescreen is-padding-left is-padding-right is-padding-top">
                      <r-label :label="'Téléphone'" :value="promoteur.phone" :redCheck='true'></r-label>
                      <div class="field has-addons">
                        <div class="control">
                          <a class="button is-static is-border is-min-width-0 is-square">
                            <span class="icon"><i class="fas fa-mobile-alt"></i></span>
                          </a>
                        </div>
                        <div class="control is-expanded">
                          <v-input id="promoteurPhone" name="promoteurPhone" @input="val => promoteur.phone = val" :model="promoteur.phone"
                            v-validate="'required'" :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Téléphone" v-mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'">
                          </v-input>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12 is-padding-top">
                      <div class="field">
                        <div class="control">
                          <gmap-input :source="address" :redCheck='true' @submit="updateAddress" :is-required="true"></gmap-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="formActionsSticky is-bottom">
                  <div class=" columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
                    <div class="column is-4 is-3-widescreen is-margin-right-small">
                      <a @click="close()" class="button is-light is-uppercase is-fullwidth">
                        <span>Annuler</span>
                      </a>
                    </div>
                    <div class="column is-4 is-3-widescreen is-margin-left-small">
                      <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit">
                        <span>Valider</span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'

  export default {
    name: 'PromoteurContact',
    data () {
      return {
        open: {},
        promoteur: {},
        address: {}
      }
    },
    props: {
      active: {
        type: Boolean,
        required: true
      },
      promoteurContact: {
        type: Object,
        required: true
      },
      params: {
        type: Object
      }
    },
    methods: {
      updateAddress ({address, location}) {
        this.$set(this, 'address', address)
        this.promoteur.address = this.address
      },
      close () {
        this.$emit('close')
      },
      submit () {
        if (this.promoteur.address) {
          if (this.promoteur.address.city === '' ||
          this.promoteur.address.line1 === '' ||
          this.promoteur.address.country === '' ||
          this.promoteur.address.zip_code === '') this.promoteur.address = {}
        }
        if (this.promoteur.company_name === '') this.promoteur.company_name = null
        if (this.promoteur.first_name === '') this.promoteur.first_name = null
        if (this.promoteur.last_name === '') this.promoteur.last_name = null
        if (this.promoteur.phone === '') this.promoteur.phone = null
        if (this.promoteur.email === '') this.promoteur.email = null
        this.$emit('submit', this.promoteur)
      }
    },
    created () {
      this.promoteur = cloneDeep(this.promoteurContact)
      if (this.promoteur.address) {
        this.address = Object.assign({}, this.promoteur.address)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/PromoteurContact.vue